import { NgModule } from '@angular/core';

import { DynamicComponentsModule } from '@shared/components/dynamic-components/dynamic-components.module';
import { SharedModule } from '@shared/shared.module';
import { RoutesRoutingModule } from './routes-routing.module';

import { DashboardsComponent } from './dashboards/dashboards.component';
import { DataSourcesComponent } from './data-sources/data-sources.component';
import { TeamsHealthComponent } from './teams-health/teams-health.component';
import { MarketPlaceComponent } from './market-place/market-place.component';
import { ProfileComponent } from './profile/profile.component';
import { ProjectCardComponent } from './project-card/project-card.component';
import { ResultComponent } from './result/result.component';
import { HomeComponent } from './home/home.component';
import { ExecutiveDashboardsComponent } from "./executive-dashboards/executive-dashboards.component";
import { TeamsHealthProfilesTableComponent } from './teams-health/teams-health-profiles-table/teams-health-profiles-table.component';
import { NzSpaceModule } from "ng-zorro-antd/space";

const COMPONENTS = [
  // page components
  HomeComponent,
  DashboardsComponent,
  DataSourcesComponent,
  TeamsHealthComponent,
  MarketPlaceComponent,
  ProjectCardComponent,
  ProfileComponent,
  ResultComponent,
  ExecutiveDashboardsComponent
];

@NgModule({
  imports: [
    SharedModule,
    RoutesRoutingModule,
    DynamicComponentsModule,
    NzSpaceModule
  ],
  declarations: [...COMPONENTS, TeamsHealthProfilesTableComponent],
  exports: [DynamicComponentsModule]
})
export class RoutesModule {}
